define('plugin/bonus/view/ClientInfoBonusListView',['require','lib/view/PaginatedCompositeView','plugin/bonus/view/ClientInfoBonusItemView','lib/view/UnwrapBehavior','Config','lib/plugin/PluginBroker'],function (require) {

    var PaginatedCompositeView = require('lib/view/PaginatedCompositeView');
    var ClientInfoBonusItemView = require('plugin/bonus/view/ClientInfoBonusItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');
    var Config = require('Config');
    var PluginBroker = require('lib/plugin/PluginBroker');
    /**
     * ClientInfoBonusListView
     *
     * @class ProductListView
     */
    return PaginatedCompositeView.extend({

        template: '#bonus_system_info_list_view',
        childView: ClientInfoBonusItemView,
        childViewContainer: '#sb_bonus_list_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        _clientModel: null,

        initialize: function () {
            var _this = this;
            PaginatedCompositeView.prototype.initialize.apply(this);

            if (Config.getInstance().getPluginStatus('client_login')) {
                var clientPlugin = PluginBroker.getInstance().getPlugin('client_login');
                this._clientModel = clientPlugin.getClientModel();

                this.listenTo(this._clientModel, 'change', function () {
                    _this.render();
                })
            }
        },

        serializeData: function () {
            var result = PaginatedCompositeView.prototype.serializeData.apply(this);
            if (this._clientModel && !_.isUndefined(this._clientModel.get('bonus_balance'))) {
                result = _.extend({
                    bonus_balance: this._clientModel.get('bonus_balance'),
                    currency: 'bonus',
                }, result);
            }
            return result;
        },

        onDomRefresh: function () {
/*            // @todo let's think how to remove this
            var errors = this.getOption('bookingModel').validationError || {};
            if (errors.global_form) {
                Backbone.Wreqr.radio.vent.trigger('status_message', 'shown');
            } else if (errors && !_.isEmpty(errors)) {
                Backbone.Wreqr.radio.vent.trigger('field_error', 'shown', {
                    'type': 'client_details'
                });
            }*/
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'client_bonus_list'
            });
        }

    });

});
